import React, { useState, useEffect, useCallback } from "react";
import { Modal } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import CommonButton from "../button";
import CommonInput from "../input";
import {
  createDeductionAction,
  updateDeductionAction,
  getDeductionInfoAction,
} from "../../containers/dashboard/action";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles(() => ({
  modalPaper: {
    position: "absolute",
  },
  container: {
    width: "350px",
    backgroundColor: theme.colors.White,
    boxShadow: "0px 0px 10px #CFD9EA80",
    borderRadius: "15px",
    padding: "50px 60px",
    "& .block": {
      marginBottom: "15px",
      "& .label": { fontSize: "18px", marginBottom: "5px" },
      "& .value": {
        fontSize: "18px",
        fontFamily: theme.fontFamily.MARKPROBOLD,
      },
    },
    "& .textArea": {
      width: "94%",
      backgroundColor: theme.colors.Zumthor,
      color: theme.colors.Violet,
      fontSize: "18px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      borderColor: theme.colors.Zumthor,
      borderRadius: "5px",
      padding: "10px",
      "&:hover": {
        borderColor: theme.colors.DodgerBlue,
        outline: "none",
      },
      "&:focus-visible": {
        borderColor: theme.colors.DodgerBlue,
        outline: "none",
      },
    },
    "& .imageContainer": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: "20px",
    },
    "& .approvalMsg": {
      color: theme.colors.Violet,
      fontSize: "24px",
      fontFamily: theme.fontFamily.MARKPROLIGHT,
      marginBottom: "40px",
    },
  },
}));

function LeaveModal({ openModal, editId, onClose }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const createDeductionMethod = useCallback(
    (data) => dispatch(createDeductionAction(data)),
    [dispatch]
  );

  const updateDeductionMethod = useCallback(
    (data, deduction_id) => dispatch(updateDeductionAction(data, deduction_id)),
    [dispatch]
  );

  const getDeductionInfoMethod = useCallback(
    (deduction_id) => dispatch(getDeductionInfoAction(deduction_id)),
    [dispatch]
  );

  const [modalStyle] = useState(getModalStyle);

  const [name, setName] = useState("");

  const dashboardReducer = useSelector((state) => {
    return state.dashboardReducer;
  });

  useEffect(() => {
    if (editId) getDeductionInfoMethod(editId);
  }, [editId, getDeductionInfoMethod]);

  useEffect(() => {
    const { createDeductionSuccess, updateDeductionSuccess, deductionInfo } =
      dashboardReducer;

    if (createDeductionSuccess || updateDeductionSuccess) {
      onClose();
      setName("");
    }
    if (deductionInfo && editId) {
      if (deductionInfo?.name) {
        setName(deductionInfo.name);
      }
    }
  }, [dashboardReducer, onClose, editId]);

  useEffect(() => {
    if (
      dashboardReducer?.createDeductionError?.length ||
      dashboardReducer?.updateDeductionError?.length
    ) {
      const ele = document.getElementsByClassName("error-container");
      if (ele && ele.length) ele[0].scrollIntoView(false);
    }
  }, [dashboardReducer]);

  return (
    <Modal
      open={openModal}
      onClose={() => {
        onClose();
        setName("");
      }}
    >
      <div style={modalStyle} className={classes.modalPaper}>
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (editId)
              updateDeductionMethod(
                {
                  name: name.trim(),
                },
                editId
              );
            else
              createDeductionMethod({
                name: name.trim(),
              });
          }}
        >
          <div className={classes.container}>
            {dashboardReducer?.createDeductionError?.length ||
            dashboardReducer?.updateDeductionError?.length ? (
              <div className={"error-container"}>
                {dashboardReducer?.createDeductionError?.length
                  ? dashboardReducer.createDeductionError.map((each, index) => (
                      <div key={index}>{each}</div>
                    ))
                  : null}
                {dashboardReducer?.updateDeductionError?.length
                  ? dashboardReducer.updateDeductionError.map((each, index) => (
                      <div key={index}>{each}</div>
                    ))
                  : null}
              </div>
            ) : null}

            <div className="block">
              <div className="label">Name</div>
              <div className="value">
                <CommonInput
                  placeholder={`Enter Name`}
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
            </div>

            <div>
              <CommonButton
                type="submit"
                text={editId ? "Update" : "Create"}
                stylevariant="secondary1"
                disabled={!name}
                style={{ marginTop: "20px", marginBottom: "20px" }}
              />

              <CommonButton
                type="button"
                text={"Cancel"}
                stylevariant="secondary2"
                onClick={() => {
                  setName("");
                  onClose();
                }}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default LeaveModal;
